import DashboardLayout from '../layouts/DashboardLayout';
// import StoreList from '../pages/store/StoreList';

export const zaloContactList = {
  path: '/zalo/list',
  component: DashboardLayout,
  name: 'Zalo list',
  children: [
    {
      path: '/',
      component: () => import (/* webpackChunkName: "about" */'../pages/zalo/ZaloList.vue'),
      meta: {
        roles: ['social-account_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách các khách hàng đã có Zalo'
        }]
      },
    }
  ],
}